export default __webpack_public_path__ + "static/media/stack_logos_express.8e77ca4f.png";